var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2.08252H7.81C4.17 2.08252 2 4.25252 2 7.89252V16.2625C2 19.9125 4.17 22.0825 7.81 22.0825H16.18C19.82 22.0825 21.99 19.9125 21.99 16.2725V7.89252C22 4.25252 19.83 2.08252 16.19 2.08252ZM12 15.9625C9.86 15.9625 8.12 14.2225 8.12 12.0825C8.12 9.94252 9.86 8.20252 12 8.20252C14.14 8.20252 15.88 9.94252 15.88 12.0825C15.88 14.2225 14.14 15.9625 12 15.9625ZM17.92 6.96252C17.87 7.08252 17.8 7.19252 17.71 7.29252C17.61 7.38252 17.5 7.45252 17.38 7.50252C17.26 7.55252 17.13 7.58252 17 7.58252C16.73 7.58252 16.48 7.48252 16.29 7.29252C16.2 7.19252 16.13 7.08252 16.08 6.96252C16.03 6.84252 16 6.71252 16 6.58252C16 6.45252 16.03 6.32252 16.08 6.20252C16.13 6.07252 16.2 5.97252 16.29 5.87252C16.52 5.64252 16.87 5.53252 17.19 5.60252C17.26 5.61252 17.32 5.63252 17.38 5.66252C17.44 5.68252 17.5 5.71252 17.56 5.75252C17.61 5.78252 17.66 5.83252 17.71 5.87252C17.8 5.97252 17.87 6.07252 17.92 6.20252C17.97 6.32252 18 6.45252 18 6.58252C18 6.71252 17.97 6.84252 17.92 6.96252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.406df81e22bba332a3689c578f96893a.svg";
export { ForwardRef as ReactComponent };